/**
 * Tipos para o sistema de chat melhorado
 */

// Tipos de mensagens e histórico
export type MessageRole = 'user' | 'assistant' | 'system';

export interface MessageHistory {
  role: MessageRole;
  content: string;
}

// Tipos de gráficos
export type ChartType = 'line' | 'bar' | 'pie' | 'area' | 'scatter' | 'heatmap';

export interface ChartData {
  tipo: ChartType;
  titulo: string;
  dados: Record<string, any>[];
  eixo_x?: string;
  eixo_y?: string[];
  labels?: Record<string, string>;
  cores?: string[];
}

// Tipos de insights
export type InsightType = 'tendencia' | 'anomalia' | 'comparacao' | 'alerta' | 'recomendacao';
export type RelevanceLevel = 'alta' | 'media' | 'baixa';

export interface Insight {
  tipo: InsightType;
  titulo: string;
  descricao: string;
  relevancia: RelevanceLevel;
  dados_suporte?: Record<string, any>;
}

// Tipos de documentos
export type DocumentType =
  | 'relatorio'
  | 'pdf'
  | 'xlsx'
  | 'txt'
  | 'planilha'
  | 'nota_fiscal'
  | 'balancete';

export interface Documento {
  tipo: DocumentType;
  titulo: string;
  descricao?: string;
  url?: string;
  dados?: Record<string, any>;
}

// Request do chat
export interface ChatRequest {
  mensagem: string;
  historico?: MessageHistory[];
  incluir_graficos?: boolean;
  incluir_insights?: boolean;
  incluir_documentos?: boolean;
  ai_provider?: AIProvider;
}

// Response do chat
export interface ChatMetadata {
  timestamp: string;
  tempo_processamento_segundos: number;
  tokens_usados: number;
  modelo: string;
  iteracoes: number;
}

export interface ChatResponse {
  resposta: string;
  graficos?: ChartData[] | null;
  insights?: Insight[] | null;
  documentos?: Documento[] | null;
  dados_brutos?: Record<string, any>[] | null;
  sql_executado?: string | null;
  metadados?: ChatMetadata;
}

// Tipo para mensagem na UI
export interface ChatMessage {
  id: string;
  role: 'usuario' | 'assistente';
  content: string;
  graficos?: ChartData[];
  insights?: Insight[];
  documentos?: Documento[];
  dadosBrutos?: Record<string, any>[];
  metadados?: ChatMetadata;
  timestamp: Date;
}

// Providers de IA disponíveis
export type AIProvider = 'backend' | 'claude';

export const AI_PROVIDERS: { value: AIProvider; label: string; description: string }[] = [
  { value: 'backend', label: 'OpenAI', description: 'Usa a API do sistema' },
  { value: 'claude', label: 'Claude', description: 'Anthropic Claude' },
];

// Settings do chat
export interface ChatSettings {
  incluir_graficos: boolean;
  incluir_insights: boolean;
  incluir_documentos: boolean;
  debug_mode: boolean;
  ai_provider: AIProvider;
}
